import { formatNumber } from "./number";

export type CurrencyDTO = { code: string; symbol: string };

export const NO_CURRENCY: CurrencyDTO = { code: "", symbol: "" };

const plain = (value: number, digits: number) =>
  formatNumber(value, { minimumFractionDigits: digits, maximumFractionDigits: digits });

export const formatMoney = (value: number | null | undefined, currency: CurrencyDTO, digits = 2): string => {
  if (value == null) return "";
  if (!currency.code) return plain(value, digits);
  try {
    return formatNumber(value, {
      style: "currency", currency: currency.code, currencyDisplay: "narrowSymbol", minimumFractionDigits: digits, maximumFractionDigits: digits,
    });
  } catch {
    return `${currency.symbol} ${plain(value, digits)}`;
  }
};

// Note: money units are stored as the word "cost" ("cost/t", "cost/m"), as the server does, and read in the mine's
// currency only where they are shown.
export const costUnit = (unit: string | null | undefined, currency: CurrencyDTO): string =>
  !unit ? "" : currency.symbol ? unit.replace(/^cost(?=$|\/)/i, currency.symbol) : unit;
